export default __webpack_public_path__ + "static/media/kit_svg3.fccb4f2d.svg";